import {IntlShape, defineMessages} from 'react-intl'

/**
 * Translated labels for frontend enums that were being painted raw into the UI.
 *
 * §10 of docs/i18n-project-plan.md: a DB/business enum rendered as a label gets
 * a translated label, while the English value keeps travelling to the API.
 * These live here — next to `catalogs.ts`, which owns the value lists — so the
 * several screens that render them share one translation instead of each
 * inventing its own.
 */

/** Mirrors `PAYMENT_STATUS_OPTIONS` in `helpers/catalogs.ts`. */
const PAYMENT_STATUS = defineMessages({
  paid: {id: 'common.paymentStatus.paid', defaultMessage: 'Paid'},
  failed: {id: 'common.paymentStatus.failed', defaultMessage: 'Failed'},
  pending: {id: 'common.paymentStatus.pending', defaultMessage: 'Pending'},
  autoPay: {id: 'common.paymentStatus.autoPay', defaultMessage: 'Auto Pay'},
  notApplicable: {
    id: 'common.paymentStatus.notApplicable',
    defaultMessage: 'Not Applicable ($0)',
  },
  selfPay: {id: 'common.paymentStatus.selfPay', defaultMessage: 'Pays on their own'},
})

/**
 * `PENDING` → "Pendiente". Unknown values fall through untouched so a status
 * added on the backend still renders instead of disappearing.
 */
export const paymentStatusLabel = (intl: IntlShape, status?: string | null): string => {
  switch (status) {
    case 'PAID':
      return intl.formatMessage(PAYMENT_STATUS.paid)
    case 'FAILED':
      return intl.formatMessage(PAYMENT_STATUS.failed)
    case 'PENDING':
      return intl.formatMessage(PAYMENT_STATUS.pending)
    case 'AUTO_PAY':
      return intl.formatMessage(PAYMENT_STATUS.autoPay)
    case 'NOT_APPLICABLE':
      return intl.formatMessage(PAYMENT_STATUS.notApplicable)
    case 'PAGA_POR_SU_CUENTA':
      return intl.formatMessage(PAYMENT_STATUS.selfPay)
    default:
      return status ?? ''
  }
}
